import React from "react";
import { Button } from "../Globalstyles/Button";
import {
  InfoContainer,
  InfoWrapper,
  InfoRow,
  Column1,
  TextWrapper,
  TopLine,
  Heading,
  Subtitle,
  BtnWrap,
  Column2,
  ImgWrap,
  Img,
} from "./InfoStyle";
import Fade from "react-reveal/Fade";
import Flip from "react-reveal/Flip";
import Slide from "react-reveal/Slide";

function Info({
  lightText,
  lightBg,
  darkText,
  description,
  id,
  imgStart,
  headLine,
  buttonLabel,
  img,
  alt,
  topLine,
  primary,
  dark,
  dark2,
}) {
  return (
    <>
      <InfoContainer lightBg={lightBg} id={id}>
        <InfoWrapper>
          <InfoRow imgStart={imgStart}>
            <Column1>
              <TextWrapper>
                <Flip left>
                  <TopLine>{topLine}</TopLine>
                </Flip>
                <Fade top>
                  <Heading lightText={lightText}>{headLine}</Heading>
                </Fade>
                <Slide bottom>
                  <Subtitle darkText={darkText}>{description}</Subtitle>

                  <BtnWrap>
                    <Button
                      to="signin"
                      smooth={true}
                      duration={500}
                      spy={true}
                      exact="true"
                      offset={-80}
                      primary={primary ? 1 : 0}
                      dark={dark ? 1 : 0}
                      dark2={dark2 ? 1 : 0}
                    >
                      {buttonLabel}
                    </Button>
                  </BtnWrap>
                </Slide>
              </TextWrapper>
            </Column1>
            <Column2>
              <ImgWrap>
                <Fade bottom>
                  <Img src={img} alt={alt} />
                </Fade>
              </ImgWrap>
            </Column2>
          </InfoRow>
        </InfoWrapper>
      </InfoContainer>
    </>
  );
}

export default Info;
